"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseAuthService = void 0;
const auth_client_1 = require("./auth-client");
class DatabaseAuthService {
    constructor(baseUrl, fetcher) {
        this.getToken = () => this.client.getToken();
        this.autoLogIn = () => this.client.autoLogIn();
        this.signIn = (email, password) => this.client.signIn(email, password);
        this.signUp = (...args) => this.client.signUp(args[0], args[1], typeof args[2] === "object" ? (args[2]?.id_organization === "coachsafely" ? "coachsafely" : "playsafely") : undefined);
        this.signOut = () => this.client.signOut();
        this.signInGoogle = () => this.client.signInGoogle();
        this.verification = (email, code) => this.client.verification(email, code);
        this.resend_verification = (email) => this.client.resend_verification(email);
        this.forgotPassword = (email) => this.client.forgotPassword(email);
        this.forgotPasswordSubmit = (email, code, password) => this.client.forgotPasswordSubmit(email, code, password);
        this.verifyResetCode = (email, code) => this.client.verifyResetCode(email, code);
        this.completePasswordReset = (email, grant, password) => this.client.completePasswordReset(email, grant, password);
        this.changePassword = (currentPassword, password) => this.client.changePassword(currentPassword, password);
        this.newPassword = (_password, _userSession) => this.client.newPassword();
        this.setAccountStatus = (userId, status) => this.client.setAccountStatus(userId, status);
        this.client = (0, auth_client_1.createAuthClient)(baseUrl, fetcher);
    }
}
exports.DatabaseAuthService = DatabaseAuthService;
